<template>
  <div class="cover-image"><img :src="image" />
   <v-btn class="button" title="Stäng" @click="onClose">
            <v-icon>mdi-arrow-collapse</v-icon>
          </v-btn>
  </div>
</template>

<script>
export default {
  name: 'CoverImage',
  props: {
    image: {
      type: String,
      required: true,
    },
  },
  methods: {
    onClose() {
      this.$emit('close')
    },
  },
  mounted() {
    this._keyListener = function (e) {
      if (e.key === 'Escape') {
        e.preventDefault()
        this.$emit('close')
      }
    }
    document.addEventListener('keydown', this._keyListener.bind(this))
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this._keyListener)
  },
}
</script>

<style lang="less" scoped>
.cover-image {
  position: relative;
  width: 100%;
    height: 500px;
  img {
    width: 100%;
    height: 500px;
    object-fit: cover;
  }
    .button {
      position: absolute;
      right: 15px;
      top: 15px;
    }
}
</style>
